import { useRecoilValue } from 'recoil';
import { studioPrintOrientationType } from 'venn-state';

export const usePeerGroupChartHeight = () => {
  const printOrientationType = useRecoilValue(studioPrintOrientationType);
  return printOrientationType === 'LANDSCAPE' ? 260 : 400;
};
